import React from 'react';
import {SubmissionDto, SubmissionStatus} from '../../scaffold';
import {Divider, Result} from 'antd';
import {ClockCircleOutlined} from '@ant-design/icons';
export default function SubmissionStatusMessage(props: {submission: SubmissionDto}) {
  const descriptions: any = {
    [SubmissionStatus.待导师审核]: '请等待导师审核后，进行下一步操作',
    [SubmissionStatus.待分配督导]: '请等待管理员分配督导',
    [SubmissionStatus.待督导审批]: '请等待督导审批',
    [SubmissionStatus.督导审批不通过]: '督导审核未通过，请申请下一批次',
    [SubmissionStatus.论文初审不通过]: '论文初审未通过，请申请下一批次',
    [SubmissionStatus.待分配盲审]: '等待管理员分配专业盲审',
    [SubmissionStatus.待盲审审批]: '请等待专业盲审审核',
    [SubmissionStatus.盲审审批不通过]: '审核未通过，请申请下一批次',
  };
  if (
    [SubmissionStatus.待导师审核, SubmissionStatus.待分配督导, SubmissionStatus.待督导审批, SubmissionStatus.待分配盲审, SubmissionStatus.待盲审审批].includes(
      props.submission.status as any,
    )
  ) {
    return (
      <div>
        <Result
          icon={<ClockCircleOutlined />}
          title={SubmissionStatus[props.submission.status as SubmissionStatus]}
          subTitle={descriptions[props.submission.status as SubmissionStatus]}
        />
        <Divider />
      </div>
    );
  }
  if ([SubmissionStatus.督导审批不通过, SubmissionStatus.论文初审不通过, SubmissionStatus.盲审审批不通过].includes(props.submission.status as any)) {
    return (
      <div>
        <Result
          status={'error'}
          title={SubmissionStatus[props.submission.status as SubmissionStatus]}
          subTitle={descriptions[props.submission.status as SubmissionStatus]}
        />
        <Divider />
      </div>
    );
  }
  return <div />;
}
// , 待上传论文, 督导审批需修改, , 待上传盲审论文, 盲审审批需修改, , 申请完成;
